module.exports = __webpack_public_path__ + "static/img/Crait_download.95ef9a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20180419/Crait_download.png
// module id = 242
// module chunks = 1